import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h1>This is Inventory Page</h1>
        </div>
    );
};

export default Inventory;